import USER_INFO from "../graphql/userInfo.gql";
import { apolloClient } from "./apollo";
/**
 * This is only mock api
 *
 */
export function getUserInfo(username) {
    return apolloClient.mutate({
        mutation: USER_INFO,
        variables: {
           username: username
        }
    })
}
